import { useState } from "react";
import ExperienceCard from "./ExperienceCard";
import ExperienceData from "./ExperienceText";
const experience = {
  mobFountain: (
    <ExperienceData>
      <h5>
        Frontend Engineer <span>@ Mob Fountain</span>{" "}
      </h5>
      <h6 className="experience-time">Oct 2025 - present</h6>
      <h6>Tech: TypeScript, React js, Next js, Tailwind Css.</h6>
      <ul>
        <li>
          Developed and maintained responsive, high-performance user interfaces
          for the company’s CMS using React.js and Tailwind CSS.
        </li>
        <li>
          Integrated REST APIs with structured content schemas, built reusable
          components and dynamic layouts, and optimized two gaming websites for
          performance, usability, and scalability.
        </li>{" "}
        <li>
          {" "}
          Collaborated closely with backend, design, and QA teams to deliver
          end-to-end features, resolve UI issues, and ensure seamless
          integrations.
        </li>{" "}
        <li>
          Leveraged modern UI libraries such as ShadCN UI, Material UI, and
          Aceternity UI to build scalable, interactive design systems, and
          implemented a game round-details feature that allows users to view
          comprehensive game information using a round ID.
        </li>
      </ul>
    </ExperienceData>
  ),
  devlupers: (
    <ExperienceData>
      <h5>
        Frontend Developer <span>@ Devlupers</span>{" "}
      </h5>
      <h6 className="experience-time">Nov 2023 - apr 2025</h6>
      <h6>Tech: React js, Next js, Socket.io, ShadCN and Tailwind Css.</h6>
      <ul>
        <li>
          Built and maintained role-based user interfaces for Admin, Users, and
          Astrologers with secure authentication, OTP-based login, and
          permission-driven access control.
        </li>
        <li>
          Implemented real-time chat interfaces with seamless user experience,
          handling message states, timers, and session flows for live
          astrologer-user interactions.
        </li>{" "}
        <li>
          {" "}
          Integrated payment workflows including wallet recharge, coupon
          application, and transaction status handling to ensure smooth and
          reliable user payments.
        </li>{" "}
        <li>
          Built responsive and accessible UI components using ShadCN UI,
          Aceternity UI, and Material UI, focusing on reusable and scalable
          design.
        </li>
        <li>
          Managed application state efficiently using modern state management
          patterns to ensure smooth UI updates and consistent data flow.
        </li>
        <li>
          Implemented state management for authentication, chat sessions, and
          payments to maintain reliable and predictable UI behavior.
        </li>
        <li>
          Collaborated with backend team to manage user data, chat sessions,
          payments, and notifications, ensuring efficient data flow and
          high-performance frontend rendering.
        </li>
      </ul>
    </ExperienceData>
  ),
  ravian: (
    <ExperienceData>
      <h5>
        Software Engineer <span>@ Ravian AI</span>{" "}
      </h5>
      <h6 className="experience-time">April 2025 - oct 2025</h6>
      <h6>
        Tech: AWS, React, JavaScript, TypeScript, Next js Github Actions, and
        Tailwind CSS
      </h6>
      <ul>
        <li>
          Built a fully responsive, modern website using React.js and Tailwind
          CSS, showcasing product plans, use cases, and AI agents with clean
          navigation and optimized layouts.
        </li>
        <li>
          Integrated FastAPI streaming APIs to enable real-time data updates and
          dynamic content rendering on the frontend.
        </li>
        <li>
          Implemented Sherlock AI legal intelligence engine for document
          summarization, knowledge retrieval from unstructured data, and
          real-time insights delivery.
        </li>
        <li>
          Designed and maintained scalable, reusable UI components to ensure a
          seamless and consistent user experience across the platform.
        </li>
        <li>
          Collaborated closely with backend and AI agent teams, including senior
          engineers with 10+ years of development experience, to deliver
          scalable, production-ready features.
        </li>
      </ul>
    </ExperienceData>
  ),
};

const Experience = () => {
  const [experienceData, setExperienceData] = useState(experience.mobFountain);
  const [activeExperience, setActiveExperience] = useState("mobFountain");
  const selectHandler = (event) => {
    setExperienceData(experience[event.target.value]);
    setActiveExperience(event.target.value);
  };

  return (
    <ExperienceCard>
      <div className="experience-card__companies">
        <button
          onClick={selectHandler}
          className={
            activeExperience === "mobFountain" ? "activeExperience" : ""
          }
          value="mobFountain"
        >
          Mob Fountain
        </button>

        <button
          onClick={selectHandler}
          className={activeExperience === "ravian" ? "activeExperience" : ""}
          value="ravian"
        >
          Ravian AI
        </button>

        <button
          onClick={selectHandler}
          className={activeExperience === "devlupers" ? "activeExperience" : ""}
          value="devlupers"
        >
          Devlupers
        </button>
      </div>
      <div className="experience-card__data">
        <p>{experienceData}</p>
      </div>
    </ExperienceCard>
  );
};
export default Experience;
